import * as React from "react";

import { cn } from "@/lib/utils";

// forwardRef: no React 18 o `ref` não passa como prop; sem isso o react-hook-form não foca o campo com erro.
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        // Layout Base
        "flex h-9 w-full min-w-0 rounded-md border border-input px-3 py-1 text-base shadow-sm outline-none transition-[color,box-shadow] md:text-sm",

        // --- CORES (CRÍTICO PARA DARK MODE) ---
        // Adicionado 'text-foreground' para garantir contraste.
        // 'bg-transparent' é base, 'dark:bg-input/30' dá o toque sutil no escuro.
        "bg-transparent text-foreground placeholder:text-muted-foreground",
        "dark:bg-input/30",

        // Seleção de texto (Highlight)
        "selection:bg-primary selection:text-primary-foreground",

        // Estilos para input type="file"
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",

        // Estados de Foco
        "focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/50",

        // Estados Desabilitados
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",

        // Estados de Erro (Aria Invalid)
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",

        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export { Input };
